import type { RouteObject } from 'react-router';

import { ROUTES } from '@/constants/routes';

import { RequireGuest } from './components/Guards';

/** Signed-out screens. */
export const guestRoutes: RouteObject[] = [
  {
    element: <RequireGuest />,
    children: [
      {
        path: ROUTES.LOGIN,
        lazy: async () => ({ Component: (await import('./pages/LoginPage')).LoginPage }),
      },
    ],
  },
];

/** Screens about the signed-in account itself, shown outside the app shell. */
export const accountRoutes: RouteObject[] = [
  {
    path: ROUTES.CHANGE_PASSWORD,
    lazy: async () => ({
      Component: (await import('./pages/ChangePasswordPage')).ChangePasswordPage,
    }),
  },
];
